// Shared helper to build a user-facing error message from API error payloads
import { ApiResponse } from '@/types/api';

export const GENERIC_ERROR_CODE = 'Generic';
export const GENERIC_DISPLAY_MESSAGE = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';

export function buildDisplayErrorMessage(body: any): string | undefined {
  if (!body) return undefined;
  if (Array.isArray(body.detail) && body.detail.length > 0) {
    return body.detail
      .map((d: any) => `${d.Field || d.field || 'Field'}: ${d.Msg || d.msg || JSON.stringify(d)}`)
      .join(', ');
  }
  if (typeof body.error === 'string') {
    return body.error === GENERIC_ERROR_CODE ? GENERIC_DISPLAY_MESSAGE : body.error;
  }
  return undefined;
}

export function buildGenericErrorPayload(): ApiResponse<unknown> {
  return {
    error: GENERIC_ERROR_CODE,
    displayErrorMessage: GENERIC_DISPLAY_MESSAGE,
    isSuccess: false,
  } as ApiResponse<unknown>;
}

export function buildErrorPayload(body?: any): ApiResponse<unknown> {
  if (body) {
    return {
      ...body,
      displayErrorMessage: buildDisplayErrorMessage(body),
      isSuccess: false,
    } as ApiResponse<unknown>;
  }
  return buildGenericErrorPayload();
}
